import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'

import {
  Container,
  Row,
  SubTitle,
  InfoText,
  Button
} from './styles'

export default function BankAccount ({
  data: bankAccount,
  onEdit,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleEdit = () => onEdit (bankAccount)

  const deleteBankAccount = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (
        `/businesses/${businessId}/bank_accounts/${bankAccount.id}`, requestConfig
      )
      setDeleting (false)
      handleDelete (bankAccount)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      <SubTitle>
        ({bankAccount.bank.code}) {bankAccount.bank.name}
      </SubTitle>
      <InfoText>
        {bankAccount.description}
      </InfoText>
      <Row style={{justifySelf: 'center'}}>
        {AuthService.hasPermission ('business_config.bank_accounts', 'edit') && (
          <Button onClick={handleEdit}>
            <FA.FaEdit color='#35A7FF' size={18}/>
          </Button>
        )}
        {AuthService.hasPermission ('business_config.bank_accounts', 'delete') && (
          <Button onClick={toggleAlertDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FA.FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir esta conta bancária?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteBankAccount}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
